import httpLogin from './HttpServiceAccount';

export function tokenLogin(token) {
  const body = {
    token: token,
  };
  return httpLogin.post('Account/TokenLogin', body);
}

export function doLogin(username, password, otp) {
  const body = {
    email: username,
    password: password,
    otp: otp,
  };
  return httpLogin.post('Account/Login', body);
}

export function Register(farstName, lastName, email) {
  const body = {
    farstName: farstName,
    lastName: lastName,
    email: email,
  };
  return httpLogin.post('Account/Register', body);
}

export function OtpEmailValidation(email, otp) {
  const body = {
    email: email,
    otp: otp,
  };
  return httpLogin.post('Account/OtpEmailValidation', body);
}

export function ResetPasswordOTP(email, otp, password, type) {
  const body = {
    email: email,
    otp: otp,
    password: password,
    type: type,
  };
  return httpLogin.post('Account/ResetPasswordOTP', body);
}

export function ValidateUserEmail(email, type) {
  const body = {
    email: email,
    initiationType: parseInt(type),
  };
  return httpLogin.post('Account/ValidateUserEmail', body);
}

export function ValidateOtp(email, otp, type) {
  const body = {
    email: email,
    otp: otp,
    otpType: parseInt(type),
  };
  return httpLogin.post('Account/ValidateOtp', body);
}

export function Initiate2FAOTP(email, type) {
  const body = {
    email: email,
    initiationType: parseInt(type),
  };
  return httpLogin.post('Account/InitiateOTP', body);
}
